"use client"
import { useState } from "react"
import "../assets/styles/blocking_viewer.css"
import blockingData from "./blocking.js"
// import memberPhotos from "./member_photo.js"


export default function BlockingViewer() {
  const [selectedSong, setSelectedSong] = useState(Object.keys(blockingData)[0])
  const [selectedCenter, setSelectedCenter] = useState(0)
  const [selectedBlocking, setSelectedBlocking] = useState(null)

  const currentSongData = blockingData[selectedSong]
  const currentCenter = currentSongData.Centers[selectedCenter]

  const getBlockingKeys = () => {
    return Object.keys(currentCenter).filter((key) => key !== "Center")
  }

  const getMembersFromString = (memberString) => {
    return memberString.split(", ").map((name) => name.trim())
  }

  const navigateCenter = (direction) => {
    const maxIndex = currentSongData.Centers.length - 1
    if (direction === "prev" && selectedCenter > 0) {
      setSelectedCenter(selectedCenter - 1)
    } else if (direction === "next" && selectedCenter < maxIndex) {
      setSelectedCenter(selectedCenter + 1)
    }
    setSelectedBlocking(null)
  }

  const MemberCard = ({ name, isCenter = false }) => {
    const imgSrc = `/assets/images/${name}.jpg`
  
    return (
      <div className={`member-card ${isCenter ? "center-card" : ""}`}>
        <div className="member-photo">
          <img
            src={imgSrc}
            alt={name}
            onError={(e) => {
              if (!e.target.src.includes("default.jpg")) {
                e.target.src = "/assets/members/default.jpg"
              }
            }}
          />
        </div>
        <div className="member-name">{name}</div>
        {isCenter && <div className="center-badge">CENTER</div>}
      </div>
    )
  }
  

  return (
    <div className="blocking-viewer">
      <header className="header">
        <h1>JKT48 New Era Setlist's Blocking</h1>
        <div className="song-selector">
          {Object.keys(blockingData).map((song) => (
            <button
              key={song}
              className={`song-btn ${selectedSong === song ? "active" : ""}`}
              onClick={() => {
                setSelectedSong(song)
                setSelectedCenter(0)
                setSelectedBlocking(null)
              }}
            >
              {song}
            </button>
          ))}
        </div>
      </header>

      <div className="content">
        <div className="center-section">
          <div className="center-navigation">
            <button className="nav-btn" onClick={() => navigateCenter("prev")} disabled={selectedCenter === 0}>
              ←
            </button>
            <div className="center-info">
              <h2>Center: {currentCenter.Center || Object.keys(currentCenter)[0]}</h2>
              <span className="center-counter">
                {selectedCenter + 1} / {currentSongData.Centers.length}
              </span>
            </div>
            <button
              className="nav-btn"
              onClick={() => navigateCenter("next")}
              disabled={selectedCenter === currentSongData.Centers.length - 1}
            >
              →
            </button>
          </div>

          <div className="center-display">
            <MemberCard name={currentCenter.Center || Object.values(currentCenter)[0]} isCenter={true} />
          </div>
        </div>

        <div className="blocking-section">
          <h3>Blocking List</h3>
          <div className="blocking-grid">
            {getBlockingKeys().map((blockingKey) => (
              <button
                key={blockingKey}
                className={`blocking-btn ${selectedBlocking === blockingKey ? "active" : ""}`}
                onClick={() => setSelectedBlocking(blockingKey)}
              >
                {blockingKey}
              </button>
            ))}
          </div>

          {selectedBlocking && (
            <div className="members-display">
              <h4>{selectedBlocking} Members</h4>
              <div className="members-grid">
              {getMembersFromString(currentCenter[selectedBlocking]).map((member, idx) => (
                <MemberCard
                  key={`${selectedSong}-${selectedCenter}-${selectedBlocking}-${member}-${idx}`}
                  name={member}
                />
              ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
